import { forwardRef } from "react";
function SvgThinArrowDown({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={23}
      height={31}
      viewBox="0.5 0 22 31"
      fill="none"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fill="currentColor"
        d="M21.652 18.894a1.5 1.5 0 0 1 0 2.12l-9.546 9.547a1.5 1.5 0 0 1-2.12 0L.438 21.015a1.5 1.5 0 1 1 2.121-2.121l6.986 6.985V1.5a1.5 1.5 0 1 1 3 0v24.379l6.985-6.985a1.5 1.5 0 0 1 2.121 0Z"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgThinArrowDown);
export default ForwardRef;
